<!-- {{testinput}} -->
<section class='item-list-table' [ngClass]='customClass'>
  <div class="item-div">
    <!---Search Text box with sort and filter icon-->
    @if (showSearch) {
      <div class='search-bar'>
        <app-table-search class="table-search" (clearsearchData)="clearData()" (filterSearch)="reservedFilter($event)" [innerfilterArray]="filterData"
          [searchdataInput]="searchData" [searchoptionalParams]="searchParms" (returnData)="receivedData($event)" (clearSearch)="clearSearch()"
          [sortData]="sortData" [showSort]="showSort" [sortByOptions]="sortByOptions" [defaultSort]="defaultSort" (sortValue)='sortTable($event)'
          [filterId]="tableId" (openFilterCheckStatus)="clickFilter($event)" (openSortCheckStatus)="clickSort($event)" [showFilterIcon] = "showFilter"
          [checkOnlineStatusforClick]="checkOnlineStatusforClick" (emitOffineforAutocompleteSearch)="emitOffineNodataforSearch()" [itemLength]='tableData?.length' [originalTableData]="originalData?.length"
        (apiSearchOption)="apiSearchOption($event)"></app-table-search> <!-- (callFocusOut)="autocompleteFO()" (callFocusIn)="autocompleteFI()" -->
      </div>
    }

    <!--Item List title and Total price-->
    @if (showItemList) {
      <div class='item-list-title'>
        <span>{{'Requisition.itemList'| translate}}</span>
        <span class='item-count'>({{this.tableData.length}})</span>
        <!--<span class='total-price' *ngIf='showTotalPrice && totalPrice != 0'>${{totalPrice.toFixed(2)}}</span>-->
        @if (showTotalPrice && this.tableData && this.tableData.length > 0) {
          <span class='total-price'>{{globalconversion.currencyFormat('en-IN',totalPrice.toString().replace(',',''),(this.tableInputs.tableId !== 'createSpoilage' && tableInputs.tableId !==  'newTransfers' && tableInputs.tableId !==  'newRequisition') ? _commonService.TransactionCurrencyCode : null)}}</span>
        }
      </div>
    }
    @if (hideOfflineTitle ? (showRowTitle && ((tableData | filterPipe: searchText : searchKey).length > 0)): showRowTitle) {
      <div class='item-list-title' [ngClass]='rowTitleClass'>
        <span>{{showRowTitleData}}</span>
      </div>
    }

  <!-- Table Starts here-->
  <div id={{tableId}}>
    <!--Table header-->
    <div class='table-header'>
      <!--Table header checkBox to select All-->
      @if (showCheckBox) {
        <div class='checkbox'>
          <app-checkbox [customCBxDisabled]="disableCheckBox"
            [customCBxChecked]="IsCheckAll" (changeEvent)="RowSelect($event,data,'All')"
          customCBxId="id_7"></app-checkbox>
        </div>
      }
      @for (header of tableHeaderData; track header) {
        <div class="header-col head-{{header.toLowerCase().split(' ').join('-')}}">
        test-HeaderData {{header | translate}}</div>
      }
    </div>
<cdk-virtual-scroll-viewport id="app-table-body" class='table-body' [itemSize]="15" minBufferPx="1500" maxBufferPx="2000" [ngClass]="{'no-data': showNodata,'showNoDataFullScreen':(showNoDataFullScreen && showNodata)}"  (scroll)="onScroll($event)" (scrolledIndexChange)="onScrolledIndexChange($event)">
  <div *cdkVirtualFor="let data of (tableData | sort: orderBy:sortOrder:sortType) | filterPipe: searchText : searchKey; index as currentIndex; trackBy: trackFunction" id="app-table-row-{{currentIndex}}" class='table-row' [ngStyle]="{'overflow-y': !data.collapse ? 'auto' : ''}" [ngClass]="{'collapse': data.collapse}">
    <!-- Table row content -->
    @if (unreadBar && data.statusId == 0) {
      <span class="message-bar"></span>
    }

    <div [ngClass]="{'swipeLeft':isSwipe && (data.id == swipeId || (data.DeviceId ? data.DeviceId == swipeId : data.itemCode ? data.itemCode == swipeId : data.id == swipeId) || (data.itemCode == swipeId) || (data.BinId==swipeId) || (data.BatchId==swipeId)),'swipe-row': (showSwipe || showNoMath)}" (swipeleft)="onPanLeft($event, data)" class={{swipeDir}} (swiperight)='toggleSwipe($event,data)'>
      <!-- CheckBox -->
      @if (showCheckBox && !disableCheckBox) {
      <div class='checkbox'>
        <app-checkbox [customCBxDisabled]="data.showCancel != undefined ? !data.showCancel : false"
          [customCBxChecked]="data.checked" customCBxId="id_7"
          (changeEvent)="RowSelect($event,data,'Single', currentIndex)"></app-checkbox>
      </div>
      }
      @if (showCheckBox && disableCheckBox) {
        <div class='checkbox'>
          <app-checkbox [customCBxDisabled]="disableCheckBox"></app-checkbox>
        </div>
      }

      <!-- Body data -->
      @for (header of tableColumn; track header; let i = $index) {
        <div class='body-col data-{{header}}' id='{{orderId[i]}} data-{{header}} data-{{data.id}}' (click)='rowClicked($event,data)'
          [ngClass]="customRowClass[header]">
          @if (header == 'itemCode') {
            <div class="body-data">
              <div [ngClass]="data.itemCollapse ? 'expanded-itemCode':'body-content collapsed-itemCode'">
                <span>#{{data[header]}}</span>
					  
              </div>
            </div>
          }
          <!-- <div class="body-data" *ngIf="header == 'itemName'">
          <div [ngClass]="data.itemCollapse ? '':'body-content'">
            <span id="itemnamecheck-{{data[header]}}">{{data[header]}}</span>
          </div>
          <div *ngIf="lengthCheck(data[header]) || data.itemCollapse" class='body-col data-expander' [ngClass]="data.itemCollapse ? 'rotate':''" id='icon-{{data.id}}' (click)="expand(data)">
            <i class="icon-down-arrow icon-expander"></i>
          </div>
        </div> -->
        @if (header == 'itemName') {
        <div class="body-data" #container>
          <div [ngClass]="data.itemCollapse ? '':'body-content'">
        
            <span id="itemnamecheck-{{data[header]}}" #namelength (click)="nameClick(data, currentIndex)">
              @if(data?.error){
              <span class="body-col data-Alert" (click)="showErrorInfo($event,data?.error)">
                <i class="icon-Alert"></i>
              </span>
              }
              @if(data?.isConsignment){
              <span class="body-col data-Consignment">
                <i class="icon-Consignment"></i>
              </span>
              }{{data[header]}}</span>
          </div>
          @if (lengthCheck(currentIndex) || data.itemCollapse) {
          <div class='body-col data-expander' [ngClass]="data.itemCollapse ? 'rotate':''" id='icon-{{data.id}}'
            (click)="expand(data, currentIndex)">
            <i class="icon-down-arrow icon-expander"></i>
          </div>
          }
        </div>
        }
        <!-- @if (header == 'qty') {
          <div class="body-data">
            <div class="body-content">
              <span>{{data[header]}}</span>
            </div>
          </div>
        } -->
        @if (header == 'conversion') {
          <div class="body-data">
            <div class="body-content">
              <span>{{'common.packSize' | translate}} : </span><span>{{data[header]}}</span>
            </div>
          </div>
        }
        @if (header == 'lotNumber' && data[header]) {
          <div class="body-data">
            <div class="body-content">
              <span>{{'common.LotID' | translate}} : </span><span>{{data[header]}}</span>
            </div>
          </div>
        }
        @if (header != 'checked' && header != 'quantity' && header != 'icon' && header != 'itemName' && header != 'itemCode' && header != 'conversion' && header != 'lotNumber' ) {
          <div class='body-data'>
            @if ((tableHeader[i] | trimLower) != ('Quantity On Hand' | trimLower) && header != 'BinNumber' && header !== 'BinCapacity' && header !== 'BinQOH' && header != 'LotNumber' && header !== 'LotId' && header !== 'LotQOH' && header !== 'LotQOHUnit' && header !== 'cost' && header != 'bidNumber' && header !== 'BatchId' && header !== 'BatchQOH' && header !== 'BatchQOHUnit' && header !== 'BatchName' && header !== 'PurchaseQTY') {
              <div class='body-header'>
                <span class='icon-header' [ngClass]="(headerIcon[i] !='' && (headerIcon[i] != 'icon-database'))? headerIcon[i]:''"></span>
                @if (tableHeaderData.length  > 0) {
                  <span>{{(data.convertToUnitTypeId!=3 && tableHeaderData[i]=="INVENTORYDETAILS.transactionUnits" ) ? "Base Unit" : tableHeaderData[i] | translate}}</span>
                }
              </div>
            }
            @if ((tableHeader[i] | trimLower) == ('Quantity On Hand' | trimLower)) {
              <div class='body-header'>
                <span class='icon-header' [ngClass]="headerIcon[i] !=''?headerIcon[i]:''"></span>
                Q.O.H
              </div>
            }
          @if (header == 'TotalValue') {
            <div class="body-header">
              <div [ngClass]="data.itemCollapse ? '':'body-content'">
                <span>{{'common.TotalValue' | translate}}</span>
              </div>
            </div>
          }
          @if (header == 'VarianceValue') {
            <div class="body-header">
              <div [ngClass]="data.itemCollapse ? '':'body-content'">
                <span>{{'common.varianceValue' | translate}}</span>
              </div>
            </div>
          }
          @if (header == 'VarianceQTY') {
            <div class="body-header">
              <div [ngClass]="data.itemCollapse ? '':'body-content'">
                <span>{{'common.VarianceQTY' | translate}}</span>
              </div>
            </div>
          }
          @if (header == 'BinCapacity') {
            <div class="body-header">
              <div [ngClass]="data.itemCollapse ? '':'body-content'">
                <span>{{'common.binCapacity' | translate}}</span>
              </div>
            </div>
          }
          @if (header == 'BinQOH') {
            <div class="body-header">
              <div [ngClass]="data.itemCollapse ? '':'body-content'">
                <span>{{'common.QOH' | translate}}</span>
              </div>
            </div>
          }
        @if (header == 'LotNumber') {				   
          <div class="body-header">
            <div [ngClass]="data.itemCollapse ? '':'body-content'">
              <span>{{'common.LotID' | translate}}</span>																																							   
            </div>
          </div>
        }
        @if (header == 'LotQOH' || header == 'LotQOHUnit') {
          <div class="body-header">
            <div [ngClass]="data.itemCollapse ? '':'body-content'">
              <span>{{'common.lotQOH' | translate}}</span>
            </div>
          </div>
        }
        @if (header == 'BatchId') {				   
          <div class="body-header">
            <div [ngClass]="data.itemCollapse ? '':'body-content'">
              <span>{{'common.BatchId' | translate}}</span>																																							   
            </div>
          </div>
        }
        @if (header == 'BatchQOHUnit') {
          <div class="body-header">
            <div [ngClass]="data.itemCollapse ? '':'body-content'">
              <span>{{'common.BatchQOH' | translate}}</span>
            </div>
          </div>
        }
        @if (header == 'BatchName') {
          <div class="body-header">
            <div [ngClass]="data.itemCollapse ? '':'body-content'">
              <span>{{'common.BatchName' | translate}}</span>
            </div>
          </div>
        }
        @if (header == 'PurchaseQTY') {
          <div class="body-header">
            <div [ngClass]="data.itemCollapse ? '':'body-content'">
              <span>{{'common.PurchaseQTY' | translate}}</span>
            </div>
          </div>
        }
        @if ((tableHeader[i] | trimLower) != ('Locations' | trimLower) && header != 'locations') {
          <div class='body-content' [ngClass]="showContentIcon && header== 'status'?'color-'+(data.statusText | trimLower):''">
            <span class='icon-before' [ngClass]="tableIcon[i] !=''?tableIcon[i]:(showContentIcon && header== 'status'?'color-'+(data.statusText | trimLower):'')"></span>
            <span class='name-icon'>{{data[header] | getIconName}}</span>
          @if (header == 'qor') {
            <span>
              <span class='quantity'>{{data[header]}}</span>
              <span class='unit'>{{data.unit}}</span>
            </span>
          }
          @if (header == 'bidNumber') {
            <span>
              <span class="bid-label">{{'common.Supp #' | translate}}:</span><span class='text'> {{data[header] ? data[header] : '-'}}</span>
            </span>
          }
          @if (header != 'qor' && header != 'priorityId' && (header != 'packSize') && header != 'cost' && header != 'bidNumber') {
            <span class='text'
              [ngClass]="tableId == 'spoilageDetails' || tableId == 'recentTransferDetails' ? 'con-full-txt' :  ((data.dropShip == 'yes' || data.dropShip == true)?'toWithDropShip':'')"
            [innerHTML]="data[header] | isEmpty | highlight: highlightText"> </span>
          }
          @if (header == 'cost' && tableId == 'newPurchase') {
            <div class="unitcost">
              <mat-form-field appearance="outline" class="item-list-editable-field">
                <mat-label>({{tableHeaderData[i] | translate}})</mat-label>
                <input appBlockPaste matInput [type]="deviceType === 'iOS' ? 'text' :_commonService.inputType" [value]="data[header]" [ngModel]="!data._showLongUnitCost ? (data[header] | currencyFormatter) : data[header]" [numbersOnly]="true" [formatter]="4"
                (focus)="data._showLongUnitCost = true"  (blur)="calculateUnitCost($event,data,currentIndex)" appIosMinusButton>
              </mat-form-field>
            </div>
          }
          @if (header == 'packSize') {
            <span class='text'
            [ngClass]="tableId == 'spoilageDetails' || tableId == 'recentTransferDetails' ? 'con-full-txt' :  ((data.dropShip == 'yes' || data.dropShip == true)?'toWithDropShip':'')">{{data[header] | decimalFormatter}} </span>
          }
          @if (header == showDropshipBeside && (data.dropShip == 'yes' || data.dropShip == true)) {
            <span class="icon-dropship dropshipIcon"></span>
          }
          @if (header == showPriorityBeside) {
            <span class="priority-icon icon-{{data[priorityKey]}}-priority"></span>
          }
        </div>
      }
      <!--Locations circle-->
      @if (((tableHeader[i] | trimLower) == ('Locations' | trimLower) || header == 'locations') && data[header]?.length > 0 && tableId != 'createSpoilage') {
        <app-supplier-locations
        [header]='header' [data]='data'></app-supplier-locations>
      }
    </div>
  }
  @if (showIcon && header == 'icon') {
    <div class='name-icon'>
      <span class='user d-inline-block'>{{data[header] | getIconName}}</span>
      @if (tableId == 'suppliers') {
        <i class="status {{data.status}}" aria-hidden="true"></i>
      }
    </div>
  }
  <!--Only Remarks text box-->
  @if (header == 'remarks') {
    <div class='body-content remarks' [ngClass]="!data.itemCollapse ? 'collapsed-remarks' : 'expanded-remarks' ">
      <mat-form-field appearance="outline" class='item-list-editable-field'>
        <mat-label>{{'common.remarks' | translate}}</mat-label>
        <input matInput [disabled]="data?.disableRemarks ? true : false" [(ngModel)]='data.remarks' (change)='remarksChanged(data.remarks,data)'>
      </mat-form-field>
    </div>
  }
  @if (data.isConsignment && header === 'isConsignment' && enableSelectBatch) {
  <div class="batch-selector">
    @if (data.ConsignmentBatch?.length > 0) {
      <i (click)="openConsignmentPopup(data)" class="icon-edit1 edit-icon"></i>
      <span class="text-with-icon body-small-regular-ex" (click)="openConsignmentPopup(data)">{{'common.ModifyBatches' | translate}}</span>
      <i (click)="clearConsignmentPopup(data)" class="icon-remove remove-icon"></i>
    }
    @if (!data.ConsignmentBatch || data.ConsignmentBatch.length == 0) {
      <i (click)="openConsignmentPopup(data)" class="icon-Link-01"></i>
      <span class="text-with-icon body-small-regular-ex" (click)="openConsignmentPopup(data)">{{'common.ChooseBatches' | translate}}</span>
    }
  </div>
  }
</div>
}

      <!-- Other elements like quantity, remarks, etc. -->
      @if (showQuantity) {
        <div class='body-col quantity-input'[ngClass]="{'red': data.quantity < 0}">
          <div class='body-content'>
            {{i}}
          <!-- Input type chnages to text for IOS, beacuse selectionStart is not supported in IOS device -->
          <div class="node-replace-div">
            <!-- @if ((!_commonService.itemFocusIn || _commonService?.selectedqtyIndex !== currentIndex)) {
              <div class="span-div" (click)="focusFn($event, currentIndex);">
                <mat-form-field appearance="outline" class="item-list-editable-field">
                  <mat-label>{{'common.qty' | translate}} ({{data.unit ? data.unit: unit}})</mat-label>
                  @if (!numbersDotOnly) {
                    <input id="read-quantity-{{currentIndex}}" #refInput [type]="(deviceType === 'iOS') ? 'text':_commonService.inputType"
                      matInput placeholder="" [numbersOnly]="true" [autofocus]="false" [value]='data.quantity | decimalFormatter'
                      [maxLength]='100' autocomplete="off" [disabled]="true">
                  }
                  @if (numbersDotOnly) {
                    <input id="read-quantity-{{currentIndex}}" #refInput [type]="(deviceType === 'iOS') ? 'text':_commonService.inputType"
                      matInput placeholder="" [numbersOnly]="true" [autofocus]="false" [value]='data.quantity | decimalFormatter'
                      [maxLength]='100' autocomplete="off" [disabled]="true">
                  }
                </mat-form-field>
              </div>
            } -->
              <div class="input-div">
                <!-- // edit -->
                <mat-label class="qty-unit-label">
                  {{'common.qty' | translate}} ({{data.unit ? data.unit: unit}})
                </mat-label>
                <mat-form-field appearance="outline" class="item-list-editable-field">
                  @if (!numbersDotOnly) {
                    <input id="quantity-{{currentIndex}}" #refInput [type]="deviceType === 'iOS' ? 'text': _commonService.inputType"
                      appBlockPaste matInput placeholder=""  [numbersOnly]="true" [autofocus]="false" [ngModel]="!data._showLong ? (data.quantity | decimalFormatter) : data.quantity"
                      (input)='updateQuantity($event.target.value,data,currentIndex)'  [maxLength]='100' autocomplete="off"
                      [disabled]="data.disableQty != undefined ? data.disableQty  : false" appIosMinusButton
                      (focus)="focusedInput($event, currentIndex, data)" (focusout)="validateQuantity($event,data, index)">
                  }
                  @if (numbersDotOnly) {
                    <input id="quantity-{{currentIndex}}" #refInput [type]="deviceType === 'iOS' ? 'text': _commonService.inputType"  appBlockPaste
                      matInput placeholder="" numbersDotOnly [autofocus]="false" [ngModel]='data.quantity | decimalFormatter : mathRandom'
                      (input)='updateQuantity($event.target.value,data,currentIndex)'  [maxLength]='100' autocomplete="off"
                      [disabled]="data.disableQty  != undefined ? data.disableQty  : false" appIosMinusButton
                      (focus)="focusedInput($event, currentIndex, data)" (focusout)="validateQuantity($event,data, index)">
                  }
                </mat-form-field>
              </div>
          </div>
        </div>
      </div>
      }
      @if (showAcknowledgementQty) {
        <div class='body-col ack-quantity-input'[ngClass]="{'red': data.AcknowledgementQty < 0}">
          <div class='body-content'>
            {{i}}
          <div class="node-replace-div">            
              <div class="input-div">
                <!-- // edit -->
                <mat-form-field appearance="outline" class="item-list-editable-field">
                  <mat-label>{{'common.ackQty' | translate}} ({{data.unit ? data.unit: unit}})</mat-label>
                  @if (!numbersDotOnly) {
                    <input id="AcknowledgementQty-{{currentIndex}}" #refInput [type]="deviceType === 'iOS' ? 'text': _commonService.inputType"
                      appBlockPaste matInput placeholder=""  [numbersOnly]="true" [autofocus]="false" [ngModel]="!data._showLongAck ? (data.AcknowledgementQty | decimalFormatter) : data.AcknowledgementQty"
                      [maxLength]='100' autocomplete="off" appIosMinusButton
                      (focus)="focusedAckInput($event, currentIndex, data)" (focusout)="validateAcknowledgementQty($event,data, index)">
                  }
                </mat-form-field>
              </div>
          </div>
        </div>
      </div>
      }
     <!--Remarks and Reasons Text box-->
@if (showReason) {
  <div class='body-col reason-select' [ngClass]="!data.itemCollapse ? 'collapsed-reason' : 'expanded-reason' " #remarksField>
    <mat-form-field appearance="outline" class='basic-textarea'>
      <mat-label>{{'common.remarks' | translate}}</mat-label>
      <textarea matInput placeholder="" style="resize: none;" [maxlength]="remarksMaxLength" [(ngModel)]='data.remarks' [FocusOnCondition] = "true"
      (input)='remarksChanged(data.remarks,data)' ></textarea> 
    </mat-form-field>
</div>
}
      <!-- More options icon -->
      @if (showMore) {
        <div class='body-col show-more'>
          @if (disableMore) {
            <i class="icon-more disableMore"></i>
          }
          @if (!disableMore) {
            <i class="icon-more" [matMenuTriggerFor]="menu"></i>
          }
          <mat-menu #menu="matMenu">
            @for (option of moreOptions; track option) {
              @if (data.showCancel || (option.id != 'cancel')) {
                <button mat-menu-item (click)='moreOptionsClicked(data,option.id)'>
                  <i [class]='option.icon'></i>
                  <span>{{option.name}}</span>
                </button>
              }
            }
          </mat-menu>
        </div>
      }

      <!-- Expand or Navigate to details icon -->
      @if (!detailsNavigate && !hideBackIcon) {
      <div class='icon-back' id="backIcon" (click)='toggleExpand($event,data, data.collapse, currentIndex)'></div>
      }
      @if (detailsNavigate) {
      <div class='icon-back icon-back-licence' id="iconback" (click)='nextIconClick($event,data)'></div>
      }
    </div>
    <!--Table row which will be visible on swipe-->
    @if (showSwipe && tableId=='documentApproval') {
      <div class='swipped-icons'
        [ngClass]="{'swipeLeft':isSwipe && (data.id == swipeId || (data.DeviceId ? data.DeviceId == swipeId : data.id == swipeId))}"
        class={{swipeDir}}>
        <div class='icons approve' (click)="iconClick($event,'approve',data)">
          <i class='icon-requisition-approved'>&nbsp;</i>
          <span class='status-text'>{{'document.approve' | translate}}</span>
        </div>
        <div class='icons deny' (click)="iconClick($event,'deny',data)">
          <i class='icon-requisition-denied'>&nbsp;</i>
          <span class='status-text'>{{'document.deny' | translate}}</span>
        </div>
        <div class='icons hold' (click)="iconClick($event,'hold',data)">
          <i class='icon-requisition-on-hold'>&nbsp;</i>
          <span class='status-text'>{{'document.hold' | translate}}</span>
        </div>
      </div>
      }
      <!--No Math -->
      @if (showNoMath && swipeId) {
      <div
        [ngClass]="{'swipeLeft':isSwipe && (data.id == swipeId || (data.DeviceId ? data.DeviceId == swipeId : data.itemCode ? data.itemCode == swipeId :  data.id == swipeId)||(data.itemCode == swipeId) || (data.BinId==swipeId) || (data.BatchId==swipeId)),'swipped-icons show-no-math':showNoMath}"
        class={{swipeDir}}>
        <div class='icons details' [ngClass]="{'disable':data.disableDetails}" (click)="iconClick($event,'details',data)">
          <i class='icon-details'>&nbsp;</i>
          <span class='status-text'>{{'common.details' | translate}}</span>
        </div>
        <div class='icons addQuantity' (click)="iconClick($event,'addQuantity',data)">
          <i class='icon-plus'>&nbsp;</i>
          <span class='status-text'>{{'common.addQuantity' | translate}}</span>
        </div>
      </div>
      }
      <!--Suspend User -->
      @if (showSuspend && swipeId) {
      <div
        [ngClass]="{'swipeLeft':isSwipe && (data.id == swipeId || (data.DeviceId ? data.DeviceId == swipeId : data.itemCode ? data.itemCode == swipeId : data.id == swipeId)),'swipped-icons show-no-math':showSuspend}"
        class={{swipeDir}}>
        <div class='icons suspend' (click)="iconClick($event,'suspend',data)">
          <i class='icon-suspend'>&nbsp;</i>
          <span class='status-text'>{{'common.Suspend' | translate}}</span>
        </div>
      </div>
      }
      <!-- showSync -->
      <div class='body-col show-sync'>
        @if (header == showSync && data.showSync) {
        <span class="icon-dropship dropshipIcon"></span>
        }
      </div>
  </div>
  @if (noSearchData && searchText && (tableData | filterPipe: searchText : searchKey).length == 0) {
    <div class="table-row no-data-message">{{'common.noDataFound' | translate}}</div>
  }
  @if (showNodata) {
    <app-no-items [addNewClass]="(showNoDataFullScreen && showNodata)?'noDataFullScreen':''"></app-no-items>
  }
</cdk-virtual-scroll-viewport>

<!--Table Body-->


</div>
</div>
</section>
